import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkout-nav',
  standalone: true,
  imports: [],
  templateUrl: './checkout-nav.component.html',
  styleUrl: './checkout-nav.component.scss'
})
export class CheckoutNavComponent {
  @Output() cancel = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();

  @Input() nextBtnText = 'Next';
  @Input() cancelBtnText = 'Cancel';
  @Input() cancelBtnType: 'tertiary' | 'secondary' = 'tertiary';
}
